var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var WTError = require('../../error');

var logger = require('../../config/logger');

var _require = require('../models'),
    RemoteTransfer = _require.RemoteTransfer;

module.exports = function (_ref) {
  var request = _ref.request,
      routes = _ref.routes;

  /**
   * Marks the transfer as completed
   * @param   {Object} transfer Transfer item.
   * @returns {Promise}
   */
  return (
    /*#__PURE__*/
    function () {
      var _finalizeTransfer = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(transfer) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                logger.info('Finalizing a transfer.');
                _context.next = 4;
                return request.send(routes.transfers.finalize(transfer));

              case 4:
                response = _context.sent;
                return _context.abrupt("return", new RemoteTransfer(response));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                throw new WTError('There was an error when finalizing the transfer.', _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function finalizeTransfer(_x) {
        return _finalizeTransfer.apply(this, arguments);
      }

      return finalizeTransfer;
    }()
  );
};